import React, { Component } from "react";
import { BrowserRouter as BrowserRouter, Route, Switch } from "react-router-dom";


import "./App.css";
import HomePage from "./HomePage";
import TimeTable from "./TimeTable";
import TimeTable2 from "./TimeTable2";
import PhoneDownload from "./PhoneDownload";
import PhoneDownloadV2 from "./PhoneDownloadV2";
import 'babel-polyfill';

import { IntlProvider } from 'react-intl'; /* react-intl imports */
import Locale from './lang/Locale'
import 'console-polyfill'
import 'url-search-params-polyfill'



global.Intl = require('intl');



class App extends Component {

    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    render() {

        var search = new URLSearchParams(window.location.search);
        let paramLang = search.get("lang");
        
        Locale.Instance.InitLang(paramLang, navigator.language);

        let _locale = Locale.Instance.getLocal();
        let _message = Locale.Instance.getMessage();

        return (
            <IntlProvider locale={_locale} messages={_message} >
                <BrowserRouter>
                    <Switch>
                        <Route path="/" exact component={HomePage} />
                        <Route path="/scanjump" exact component={HomePage} />
                        <Route path="/phonedownload_old" component={PhoneDownload} />
                        <Route path="/phonedownload" component={PhoneDownloadV2} />
                        <Route path="/timetable2" component={TimeTable} />
                        <Route path="/timetable" component={TimeTable2} />
                    </Switch>
                </BrowserRouter>
            </IntlProvider>
        );
    }
}

export default App;
